<template>
    <div>
        <Row :gutter="16">
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Row>
                    <Form :model="formItem" :label-width="85" label-position="right" ref="form">
                        <Row>
                            <Col>
                                <FormItem :label="t.pic.name" prop="name">
                                    <Input v-model="formItem.name" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.pic.thumb" prop="thumb">
                                    <Input v-model="formItem.thumb" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.pic.image" prop="image">
                                    <Input v-model="formItem.image" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.pic.sortOrder" prop="sortOrder">
                                    <Input v-model="formItem.sortOrder" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.pic.status" prop="status">
                                    <Input v-model="formItem.status" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.pic.createBy" prop="createBy">
                                    <Input v-model="formItem.createBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.pic.createTime" prop="createTime">
                                    <Input v-model="formItem.createTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.pic.updateBy" prop="updateBy">
                                    <Input v-model="formItem.updateBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.pic.updateTime" prop="updateTime">
                                    <Input v-model="formItem.updateTime" readonly></Input>
                                </FormItem>

                                <FormItem :label="t.pic.description" prop="description">
                                    <Input v-model="formItem.description" type="textarea" readonly></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span style="float: right;">
                                     <div class="pic-upload-list" v-if="formItem.image != null">
                                        <img :src="formItem.image"/>
                                        <div class="pic-upload-list-cover">
                                            <Icon type="ios-eye-outline" @click="openPreviewImageModal(0)"></Icon>
                                        </div>
                                    </div>
                                    <div class="img-drag" v-else>
                                        <div style="width: 58px;height:58px;line-height: 58px;">
                                            <Icon type="ios-camera" size="20"></Icon>
                                        </div>
                                    </div>
                                    <div class="pic-upload-list" v-if="formItem.thumb != null">
                                        <img :src="formItem.thumb"/>
                                        <div class="pic-upload-list-cover">
                                            <Icon type="ios-eye-outline" @click="openPreviewImageModal(1)"></Icon>
                                        </div>
                                    </div>
                                    <div class="img-drag" v-else>
                                        <div style="width: 58px;height:58px;line-height: 58px;">
                                            <Icon type="ios-camera" size="20"></Icon>
                                        </div>
                                    </div>
                                </span>
                                <Modal v-model="previewImageModal" :width="previewImageModalWidth">
                                    <img :src="previewImage" style="max-width:100%;max-height:100%;">
                                    <div slot="footer">
                                        {{formItem.previewImageName}}
                                    </div>
                                </Modal>
                            </Col>
                        </Row>
                    </Form>
                    <a :href="downImg" download="cns.png" ref="downloadDom"></a>
                </Row>
            </Card>
        </Row>
    </div>
</template>

<script>
import { getImageSizeInfo, getPicInfo } from '@/api/pic';

export default {
    name: 'content_pic_detail',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            imageSizeList: [],
            previewImageModal: false,
            previewImage: null,
            previewImageWidth: 300,
            downImg: '#',
            formItem: {
                name: '', //图片名
                image: null,
                thumb: null,
                sortOrder: 0,
                status: '1',
                description: '', //图片详细 //图片URL
                type: '1', //0サムネイル、１普通画像、2音声３、ビデオ４、スライドショー（幻灯片）
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
                imageType: '',
                previewImageName: '',
            },
        };
    },
    computed: {
        previewImageModalWidth() {
            return this.previewImageWidth;
        },
    },
    methods: {
        //图片预览
        openPreviewImageModal(index) {
            const imageSizeInfo = this.imageSizeList[index];
            if (imageSizeInfo.range === 'image') {
                this.previewImage = this.formItem.image;
                this.formItem.previewImageName = this.t.pic.image;
            } else if (imageSizeInfo.range === 'thumb') {
                this.previewImage = this.formItem.thumb;
                this.formItem.previewImageName = this.t.pic.thumb;
            }
            let width = parseInt(imageSizeInfo.width) + 32;
            this.previewImageWidth = width < 100 ? 105 : width;
            this.previewImageModal = true;
        },
        async init() {
            //得到图片大小情报
            const imageSizeInfo = await getImageSizeInfo();
            if (imageSizeInfo.imageSizeList != null) {
                this.imageSizeList = imageSizeInfo.imageSizeList;
            }

            //得到图片的信息
            const picInfo = await getPicInfo(this.$route.params.id);
            if (picInfo.picture != null) {
                this.formItem = picInfo.picture;
                //状态判断
                if (picInfo.picture.status === '0') {
                    this.formItem.status = this.t.pic.close;
                } else if (picInfo.picture.status === '1') {
                    this.formItem.status = this.t.pic.open;
                }
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
.btn {
    cursor: pointer;
    color: #515a6e;
}
</style>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    /*cursor: pointer;*/
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    display: inline-block;
    width: 58px;
    height: 58px;
    margin-left: 10px;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.sub-cropper {
    height: 600px;
    margin-bottom: 10px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1080px) {
    .sub-cropper {
        height: 600px;
    }
}

.pic-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}

.pic-upload-list img {
    width: 100%;
    height: 100%;
}

.pic-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.pic-upload-list:hover .pic-upload-list-cover {
    display: block;
}

.pic-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>
